import {AnyAction} from 'redux';

import {mergeResponse, QueryState} from './Response';

import Types from '../../actions/Types';

import ActorCostume from '../../../domain/entities/ActorCostume';
import PaginatedResult from '../../../domain/results/PaginatedResult';

export default function reducer(
  state: QueryState = {},
  action: AnyAction,
): QueryState {
  switch (action.type) {
    case Types.IndexActorCostumesSuccess: {
      const result = action.payload as PaginatedResult<ActorCostume>;
      return mergeResponse(state, result);
    }
    default:
      return state;
  }
}
